import { useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import CompanyComponent from "../components/CompanyComponent";
import debtIcon from "../../../assets/design-revamp-company/equity-component/equity-icon.svg";
import {
  updateDebtProject,
  getDebtProject,
  deleteDebtProject,
} from "../../../apis/Business/DebtProjectApi";
import Debt from "../Debt";
import { AlertV2 } from "../../../components/Alert";
import { useTranslation } from "react-i18next";

const EditDebt = () => {
  const { t } = useTranslation();
  const urlParams = new URLSearchParams(window.location.search);
  const { debtId } = useParams();
  const year = urlParams.get("year");
  const [vatNumber, setVatNumber] = useState("");
  const [countryOrigin, setCountryOrigin] = useState("");
  const [investeeName, setInvesteeName] = useState("");
  const [yourShare, setYourShare] = useState("");
  const [scope1, setScope1] = useState("");
  const [scope2, setScope2] = useState("");
  const [deleteFacilityAlert, setDeleteFacilityAlert] = useState(false);
  const [cutOffAddress, setCutOffAddress] = useState("");
  const [errorMessage, setErrorMessage] = useState({});
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (year == null || year === "") {
      navigate("/company");
    }
  }, [navigate, year]);

  const handleMove = useCallback(
    () => navigate("/company", { replace: true }),
    [navigate]
  );

  const handleFormDataChange = (updatedFormData) => {
    setInvesteeName(updatedFormData.investeeName);
    setVatNumber(updatedFormData.vatNumber);
    setCountryOrigin(updatedFormData.countryOrigin);
    setYourShare(updatedFormData.yourShare);
    setScope1(updatedFormData.scope1);
    setScope2(updatedFormData.scope2);
  };

  const save = () => {
    updateDebtProject({
      objectId: debtId,
      vat_num: vatNumber,
      investee_name: investeeName,
      country: countryOrigin,
      share_of_costs: yourShare,
      scope_1: scope1,
      scope_2: scope2,
      setErrorMessage: setErrorMessage,
      use_swal: true,
      callback: () =>
        setTimeout(() => {
          window.location.reload();
        }, 1000),
    });
  };

  useEffect(() => {
    getDebtProject({
      objectId: debtId,
      setVatNumber: setVatNumber,
      setInvesteeName: setInvesteeName,
      setCountryOrigin: setCountryOrigin,
      setYourShare: setYourShare,
      setScope1: setScope1,
      setScope2: setScope2,
      setIsDataLoaded: setIsDataLoaded,
    });
  }, [debtId]);

  const handleDelete = () => {
    setDeleteFacilityAlert(true);
  };

  const handleSave = () => {
    save();
    return;
  };

  return (
    <>
      <div
        className="companydetail"
        style={{
          display: "flex",
          flexDirection: "row",
          paddingRight: "42px",
          marginTop: "20px",
        }}
        id="debt-id"
      >
        <CompanyComponent
          name={investeeName}
          address_line_1={cutOffAddress !== "" ? cutOffAddress : countryOrigin}
          iconComponent={debtIcon}
        />
        {isDataLoaded && (
          <Debt
            initialData={{
              vatNumber,
              investeeName,
              countryOrigin,
              yourShare,
              scope1,
              scope2,
            }}
            isNewFacility={false}
            onFormDataChange={handleFormDataChange}
            handleSave={handleSave}
            errorMessage={errorMessage}
            setCurrentName={setInvesteeName}
            setCutOffAddress={setCutOffAddress}
            handleDelete={handleDelete}
          />
        )}
      </div>
      <AlertV2
        open={deleteFacilityAlert}
        title={t("DELETE_FACILITY_2")}
        accept={() => {
          deleteDebtProject({ objectId: debtId });
          handleMove();
        }}
        decline={() => setDeleteFacilityAlert(false)}
      />
    </>
  );
};
export default EditDebt;
